import SmsTaskPreviewLayoutWeb from './SmsTaskPreviewLayout.web';
import MobileLayout from './SmsTaskPreviewLayout.mobile';
import { isReactNative } from 'ui-builder';

export default isReactNative() ? MobileLayout : SmsTaskPreviewLayoutWeb;
